import type { SerializedRichBlockNode } from "@resource/atlas/content-editor/__utils/rich-blocks";

import type { PersistableCalendarEvent } from "./calendar-utils/types";

// config
// ------

export const RICH_BLOCK_NAME = "share-availability";

export const DEFAULT_DATA: ShareAvailabilityData = {
  title: "",
  candidateAvailabilityId: "",
  availabilityRequestId: "",
  availabilities: [],
  overlayCalendars: false,
  edited: false,
};

// types
// -----

export type ShareAvailabilityName = typeof RICH_BLOCK_NAME;

export type ShareAvailabilityData = {
  title: string;
  candidateName?: string;
  candidateAvailabilityId: string;
  availabilityRequestId: string;
  availabilities: PersistableCalendarEvent[];
  overlayCalendars: boolean;
  edited: boolean;
};

export type SerializedShareAvailabilityNode = SerializedRichBlockNode<
  ShareAvailabilityName,
  ShareAvailabilityData
>;
